import styled from "styled-components";

import { BillingDataPreviewStyledProps as Props } from "./BillingDataPreview.types";
import { DeleteBillingDataModal as ModalProps } from "./BillingDataPreview.types";
import InfoActionModal from "components/global/InfoActionModal/InfoActionModal";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { mobile } = BREAKPOINTS;

const BillingDataPreviewStyled = styled.div<Props>`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  height: 4.8rem;
  padding: 0 2.4rem;
  padding-right: 1.6rem;
  pointer-events: ${props => (props.disabled ? "none" : "initial")};

  @media (max-width: ${mobile}px) {
    padding: 0 0.8rem;
  }

  .ChooseAddress {
    &__loading {
      svg {
        height: 2rem;
        width: 2rem;
        animation: rotate 0.6s linear infinite;
      }
    }
  }
`;

export const DeleteBillingDataModal = styled(InfoActionModal)<ModalProps>`
  path {
    fill: var(--palette-primary);
  }

  border-radius: 1.6rem;
  background-color: var(--palette-white);

  .DeleteBillingDataModal {
  }
`;

export const ModalHeaderStyled = styled.div`
  padding: 1.6rem 2.4rem;
  font-weight: 600;
  font-size: 1.6rem;
  text-align: center;
  flex: 1;

  .ModalHeaderStyled {
    &__header {
      color: var(--palette-black-s0-l10);
    }
  }
`;

export default BillingDataPreviewStyled;
